import helpers from "./helpers"

export const productUnitData = {
   "product_variant_id": "",
   "customer_id": "",
   "customer_name": "",
   "dealer_id": "",
   "dealer": "",
   "order_type": "order_type",
   "order_id": "",
   "order_no": "",
   "brand_id": "",
   "brand": "",
   "model": "",
   "serial_no": "",
   "indoor_serial": "",
   "outdoor_serial": "",
   "qr_code": "",
   "purchased_date": "",
   "cleaning_cycle_days": "",
   "proof_of_purchase": "",
   "remarks": "",
   "unit_location": "",

   "polarcare_plus": 0,
   "polarcare_start_date": ""
}

export const serviceRequestData = {
   "service_no": "",
   "customer_id": "",
   "customer_name": "",
   "email": "",
   "phone_no": "",
   "service_type_id": "",
   "sub_service_type_id": "",
   "contact_person": "",
   "contact_person_mobile": "",
   "full_address": "",
   "address_1": "",
   "address_2": "",
   "city": "",
   "province": "",
   "remarks": "",
   "complaint": "",
   "items": [],
   "status": 2,
   "status_name": "",
   "service_type_name": "",
   "sub_service_type_name": "",

   "schedule_date": "",
   "extra_info": "",
   "labor_fee": 0,
   "members": [],

   "assessment_date": "",
   "assessment": "",
   "recommendation": "",

   "schedule_date": "",
   "extra_info": "",
   "labor_fee": "",
   "members": [],

   
   "received_date": "",
   "receiver_name": "",
   "receiver_signature": "",
   "acceptance_remarks": "",
}

export const productUnitsStatus = [ 
   {"label": "OK", "id": "OK"}, 
   {"label": "CLEANED", "id": "CLEANED"}, 
   {"label": "CLEAN DUE", "id": "CLEAN DUE"}, 
   {"label": "SERVICE", "id": "SERVICE"}, 
   {"label": "OUT", "id": "OUT"}, 
]